/**
 * React remount key for the page Component in `_app`.
 * Keep path and dynamic ids; ignore query/hash so in-page URL state
 * (search, tabs, pagination) does not remount the screen.
 */
export const getAppPageKey = (asPath: string): string =>
  asPath.split("?")[0]?.split("#")[0] ?? asPath
